import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../UI/Button';

type Props = {
  children: React.ReactNode;
};

export const AgentPlatformAdminGate: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();

  if (user?.isAdmin) {
    return <>{children}</>;
  }

  return (
    <div className="max-w-lg mx-auto mt-16 p-8 bg-white rounded-lg shadow border border-gray-200 text-center">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Acesso restrito</h2>
      <p className="text-gray-600 mb-6">
        A edição da Plataforma Agêntica está disponível apenas para administradores do sistema.
      </p>
      <Link to="/admin/control-panel">
        <Button variant="secondary">Voltar ao painel</Button>
      </Link>
    </div>
  );
};
